/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Scalability_TitleInputs */



/**
* | output |
* | --- |
* | "Fastest Blockchains by TPS (Transactions Per Second)" |
*
* @param {Dashboard_Scalability_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_scalability_title = /** @type {((inputs?: Dashboard_Scalability_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Scalability_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Fastest Blockchains by TPS (Transactions Per Second)")
});